<template src="./index.html">
</template>

<script>
	import {getdata} from'./data.js'
	import uploadFile from "../../../common/uploadFile/index.vue";
	import base from '../../../../../configHttp.js'
	import subject from './subject/index.vue'
	import {init,query,getFirstNum,detailadd,queryNsrinfo,summaryquery} from'../../../../api/cyry.js'
	import {getdata as getdataI} from'./subject/data.js'
	export default{
		 name: "cyry",
		components: {
		  uploadFile,
		  subject,
		},
		data(){
			return{
				ywdiag:false,
				mxdj:false,
				title:'',
				searchdata:getdata().searchdata,
				searchlist:getdata().searchlist,
				uploaddiag:false,
				filetype:'',
				showdownload:true,
				tableDataone:getdataI().tableDataone,
				tableDatatwo:getdataI().tableDatatwo,
				tableDatathree:getdataI().tableDatathree,
				tableDatas:getdataI().tableData,
				headData:getdata().headData,
				tableData:[{
					nsrsbh:1223
				}],
				tablelyData:[{
					yingsbm:1123
				}],
				subjectlist:{
					nsrmc:[],
					year:'',
					nsrsbh:'',
				},
				json:getdata().json,
				formdata:getdata().formdata,
				headlyData:getdata().headlyData,
				formlist:getdata().formlist,
				sjlydiag:false,
				pagination:getdata().pagination,
				outlist:[],
				shaidiag:false,
				typecy:0,
				tablekey:0,
				overlength:0,
			}
		},
		created(){
			let tiem = new Date()
			this.searchdata.nianf = `${tiem.getFullYear()}`
			this.inits()
			this.nsr()
			
		},
		methods:{	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			selectchange(e){
				this.innner(this.formdata.e)
			},
			nsr(){
				this.subjectlist.nsrmc = []
				queryNsrinfo().then(res=>{
					 if(res.data.code==1){
						res.data.data.map(item=>{
							this.subjectlist.nsrmc.push({
								label:item.nsrmc,
								value:item.nsrsbh,
							})
						})
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			hzck(e){
				 this.typecy = e.shenbzq
				 this.title = '汇总详情'
				 this.subjectlist.nsrsbh = e.nsrsbh
				 this.subjectlist.year = e.nianf
				 this.subjectlist.quan = e
				 let params = {
					 nianf:e.nianf,
					 nsrsbh:e.nsrsbh,
					 shenbzq:e.shenbzq,
				 }
				 summaryquery(params).then(res=>{
				 	 if(res.data.code==1){
						 Object.keys(this.tableDataone[0]).map(key=>{
							 this.tableDataone[0][key] = '0'
						 })
						 Object.keys(this.tableDatatwo[0]).map(key=>{
							 this.tableDatatwo[0][key] = '0'
						 })
						 Object.keys(this.tableDatathree[0]).map(key=>{
							 this.tableDatathree[0][key] = '0'
						 })
						 Object.keys(this.tableDatas[0]).map(key=>{
							 this.tableDatas[0][key] = '0'
						 })
						 if(res.data.data.length!=0){
							 res.data.data.map(item=>{
							 	 if(Math.trunc(item.code/4)==0||item.code/4==1){
							 	 	this.tableDataone[0]['firstNum'+item.code] = item.firstNum
							 	 	this.tableDataone[0]['lastNum'+item.code] = item.lastNum
							 		this.tableDatas[0]['firstNum'+item.code] = item.firstNum
							 		this.tableDatas[0]['lastNum'+item.code] = item.lastNum
							 	 }else if(Math.trunc(item.code/4)==1||item.code/4==2){
							 	 	this.tableDatatwo[0]['firstNum'+item.code] = item.firstNum
							 	 	this.tableDatatwo[0]['lastNum'+item.code] = item.lastNum
							 	 }else {
							 	 	this.tableDatathree[0]['firstNum'+item.code] = item.firstNum
							 	 	this.tableDatathree[0]['lastNum'+item.code] = item.lastNum
							 	 }
							 })
						 }
						
						this.ywdiag = true
				 	}else{
				 		this.$message.error(res.data.msg)
				 	}
				 })
			},
			nextmxdj(){
				let params = {
					...this.formdata
				}
				detailadd(params).then(res=>{
					 if(res.data.code==1){
						this.mxdj = false
						this.$message.success('新增成功')
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			mxdjs(e){
				if(e.shenbzq==1){
					this.formlist[3].label = '月初从业人数'
					this.formlist[4].label = '月末从业人数'
				}else{
					this.formlist[3].label = '季初从业人数'
					this.formlist[4].label = '季末从业人数'
				}
				if(e.suosqbz==1){
					Object.keys(this.formdata).map(key=>{
						this.formdata[key] = ''
					})
					this.formlist[2].selectval = []
					this.innner(e)
				}
			},
			innner(e){
				let params = {
					 id:e.id,
					 nsrsbh: e.nsrsbh,
					 shenbzq: e.shenbzq,
					 suosq:e.suosq||this.formdata.suosq
				}
				getFirstNum(params).then(res=>{
					 if(res.data.code==1){
						 // this.searchdata.nianf = res.data.data.suosq.substr(0,3)
							this.formdata.cyryId = e.id
							this.formdata.nsrmc = e.nsrmc
							this.formdata.shenbzq = e.shenbzq
							this.formdata.shenbname = e.shenbzq==1?'按月申报':'按季申报'
							this.formdata.firstNum =  res.data.data.firstNum
							this.formlist[2].selectval = res.data.data.suosqNameDownList
							this.formdata.suosq = res.data.data.suosq
							this.mxdj = true
							this.formdata.e = e
							this.page()
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			inits(){
				init().then(res=>{
					 if(res.data.code==1){
							this.page()
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			page(){
				let params = JSON.parse(JSON.stringify(this.searchdata));
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				query(params).then(res=>{
					 if(res.data.code==1){
						this.tableData = res.data.data.records
						this.pagination.total = res.data.data.total
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			closediag(){
				this.ywdiag = false
			},
			changeBatchShujlyButton(value){
			},
			submitSearch(){
				
			},
			getJxzcInfo(){//选择日期
				this.page()
			},
			dc(){//导出文件	
				let ids = []
				let box =  this.$refs.tablebox.getSelectionval()
				box.map(item=>{
					ids.push(item.id)
				})
				let params = {
					downUrl:base.baseURL+'/cyry/list/export',
					typeObj:{
						toForm:false,
						fileName:"从业人员数据" + this.$timestampToStr(new Date(), "yyyyMMdd"),
						fileType:'xlsx',
					},
					params:{
						pageShowListPojo:{...this.searchdata},
						json:this.json,
						ids,
					}
				}
				this.$downloadcommon(params)
			},
			getuploadparams(){
				
			},
			nextsc(){//批量导入确定
				
			},
			fordownloadmb(){
				
			},
			sizechange(e){//分页切换
				  this.pagination.pageSize = e;
				  this.page()
			},
			currentChange(e){//页码切换
				 this.pagination.pageNum = e;
				 this.page()
			},
			submitSearch() {
			  this.pagination.pageNum = 1;
			  this.pagination.paginationkey++;
			  this.page()
			},
			sizechangely(){//数据来源分页切换
				
			},
			currentChangely(){//数据来源页码切换
				
			},
			closeshaidiag(){
				 this.shaidiag = false;
			},
			confirmfilter(){
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
		}
	}
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>